import React, { useEffect } from 'react';

function ModernOrderSidebar({ isOpen, onClose, pedido }) {
  // Prevenir scroll do body quando sidebar está aberta
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  if (!pedido) return null;

  const { dados, produtos } = pedido;

  const formatPrice = (price) => {
    if (price === undefined || price === null || price === '') return 'R$ 0,00';
    if (typeof price === 'string') {
      const numericPrice = parseFloat(price.replace(',', '.'));
      if (isNaN(numericPrice)) return 'R$ 0,00';
      return numericPrice.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    }
    if (typeof price === 'number' && !isNaN(price)) {
      return price.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    }
    return 'R$ 0,00';
  };

  return (
    <>
      {/* Overlay */}
      <div
        className={`modern-sidebar-overlay ${isOpen ? 'show' : ''}`}
        onClick={onClose}
      />

      {/* Sidebar */}
      <div className={`modern-order-sidebar ${isOpen ? 'show' : ''}`}>
        {/* Header */}
        <div className="modern-order-sidebar-header">
          <div>
            <h5 className="mb-1">
              <i className="bi bi-receipt me-2"></i>
              Detalhes do Pedido
            </h5>
            <p className="text-muted mb-0 small">
              #{typeof dados[0] === 'string' ? dados[0].substring(0, 12) : dados[0]}
            </p>
          </div>
          <button
            className="btn-close"
            onClick={onClose}
            aria-label="Fechar"
          />
        </div>

        {/* Conteúdo */}
        <div className="modern-order-sidebar-body">
          {/* Informações do Pedido */}
          <div className="modern-card mb-3">
            <div className="card-body">
              <h6 className="mb-3">
                <i className="bi bi-info-circle me-2"></i>
                Informações
              </h6>
              <div className="d-flex flex-column gap-2">
                <div className="d-flex justify-content-between">
                  <span className="text-muted">Data:</span>
                  <strong>{dados[1]}</strong>
                </div>
                {dados[2] && (
                  <div className="d-flex justify-content-between">
                    <span className="text-muted">Status:</span>
                    <span className="badge bg-warning text-dark">
                      {dados[2]}
                    </span>
                  </div>
                )}
                <div className="d-flex justify-content-between">
                  <span className="text-muted">Itens:</span>
                  <strong>{produtos.length}</strong>
                </div>
                <div className="d-flex justify-content-between">
                  <span className="text-muted">Total:</span>
                  <strong>{formatPrice(produtos.reduce((total, produto) => total + produto[2] * produto[3], 0).toFixed(2))}</strong>
                </div>
              </div>
            </div>
          </div>

          {/* Lista de Produtos */}
          <div className="modern-card">
            <div className="card-body">
              <h6 className="mb-3">
                <i className="bi bi-box-seam me-2"></i>
                Produtos ({produtos.length})
              </h6>
              <div className="d-flex flex-column gap-2">
                {produtos.map((produto, index) => {
                  const [nome, imagem, quantidade, precoUnit] = produto;
                  return (
                    <div
                      key={index}
                      className="d-flex align-items-start p-2 rounded bg-light"
                    >
                      <img
                        src={imagem}
                        alt={nome}
                        className="rounded me-3"
                        style={{
                          width: '60px',
                          height: '60px',
                          objectFit: 'cover',
                          flexShrink: 0
                        }}
                        onError={(e) => {
                          e.target.src = 'https://via.placeholder.com/60x60/e5e7eb/9ca3af?text=Img';
                        }}
                      />
                      <div className="flex-grow-1 min-w-0">
                        <h6 className="mb-1 fs-6">{nome}</h6>
                        <div className="d-flex align-items-center gap-2">
                          <span className="badge bg-secondary">
                            Qtd: {quantidade}
                          </span>
                        </div>
                        <h6 className="mb-1 fs-6"><b>Preço unitário:</b> {formatPrice(precoUnit)}</h6>
                        <h6 className="mb-1 fs-6"><b>Preço total:</b> {formatPrice((quantidade * precoUnit).toFixed(2))}</h6>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="modern-order-sidebar-footer">
          <button
            className="btn btn-outline-modern w-100"
            onClick={onClose}
          >
            <i className="bi bi-x-lg me-2"></i>
            Fechar
          </button>
        </div>
      </div>
    </>
  );
}

export default ModernOrderSidebar;
